import { Injectable } from "@angular/core";
import { NodeManager } from "@app/utilities/foblex-flow/node-manager";
import { FragQueryService } from "src/injectables/frag-query.service";
import { DeviceNode } from "./device-node/device-node.component";
import { combineLatest } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FlowNodeInteractor {
    constructor(
        private readonly fragQuery: FragQueryService,
        private readonly nodeManager: NodeManager,
    ) {}

    public initializeNodes() {
        combineLatest([this.fragQuery.nodes$, this.fragQuery.devices$]).subscribe(([nodes, devices]) => {
            this.nodeManager.removeAllNodes();
            if (nodes.length) {
                nodes.forEach(node => {
                    const device = devices.find(d => d.id === node.resourceId);
                    if (!device) {
                        console.warn(`Device with id ${node.resourceId} not found for node ${node.id}. Skipping node creation.`);
                        return;
                    }
                    const deviceNode = new DeviceNode(device, node);
                    this.nodeManager.addNode(deviceNode);
                });
            }
        });
    }
}